import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngxs/store';
import { LangTagPipe } from 'src/app/features/shared-components/lang-tag.pipe';
import { AppFeaturesState } from 'src/app/portal/app-feature.state';
import { LoadingState } from '../loading.state';
import { AppFeaturesService } from 'src/app/portal/app-features.service';

@Component({
	selector: 'app-update-required',
	templateUrl: './update-required.component.html',
	styleUrls: ['./update-required.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IonicModule, CommonModule, LangTagPipe],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	standalone: true,
})
export class UpdateRequiredComponent {
	lang$ = this.store.select(AppFeaturesState.langData);
	loadingWithSpinner$ = this.store.select(LoadingState.loadingWithSpinner);

	storeLink = signal<string>('');
	storeText: string;

	constructor(
		private store: Store,
		// private navController: NavController,
		private appFeaturesState: AppFeaturesState,
		private appFeaturesService: AppFeaturesService
	) // private firebaseService: FirebaseService,
	// private toastService: ToastService,
	{
		this.storeText = this.appFeaturesState.isIos ? 'App Store' : 'Google Play'
		this.appFeaturesService.getInfo('app_info').subscribe((data) => {
			this.storeLink.set(this.appFeaturesState.isIos ? data.data.appInfo.ios.storeUrl : data.data.appInfo.android.storeUrl);
		});
	}
}
